import React from "react";
import "./exp.css";
import mit from "../../assets/mit.jpeg"; 

const Experience = () => {
  return (
    <section id="experience">
      <span className="expTitle">My Internship Details</span>
      <span className="expDesc">
        Overview of my professional experience.
      </span>
      <div className="expBars">
        <div className="expBar">
          <img src={mit} alt="MIT" className="expBarImg" />
          <div className="expBarText">
            <h2>Summer Internship</h2>
            <p>
              Manipal Institute of Technology (MIT) – Summer 2024<br />
              Duration: May 2024 – July 2024<br />
              Project: Abstractive Text Summarization
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
